export enum AllowNotificationMessage {
  ON_HOLD = 'Notifications on this order are on hold.',
  ALLOWED = 'Notifications on this order are allowed.',
}
